import React from 'react';
import Card from '../Card';

interface WeeklySummaryCardProps {
  weeklyTotal: number;
  plannedHours: number;
  variance: number;
  hasWeeklyPlan: boolean;
}

const WeeklySummaryCard: React.FC<WeeklySummaryCardProps> = ({
  weeklyTotal,
  plannedHours,
  variance,
  hasWeeklyPlan,
}) => {
  return (
    <Card variant="glass" className="hover:-translate-y-1 transition-all duration-300">
      <Card.Header title="Weekly Summary" />
      <Card.Body>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--spacing-md)' }}>
          <div>
            <div style={{ fontSize: 'var(--font-size-sm)', color: 'var(--gray-600)', marginBottom: 'var(--spacing-xs)' }}>
              Total Hours Logged
            </div>
            <div style={{ fontSize: 'var(--font-size-3xl)', fontWeight: 700, color: 'var(--primary)' }}>
              {weeklyTotal.toFixed(1)}h
            </div>
          </div>

          {hasWeeklyPlan && (
            <>
              <div>
                <div style={{ fontSize: 'var(--font-size-sm)', color: 'var(--gray-600)', marginBottom: 'var(--spacing-xs)' }}>
                  Planned Hours
                </div>
                <div style={{ fontSize: 'var(--font-size-2xl)', fontWeight: 600 }}>
                  {plannedHours.toFixed(1)}h
                </div>
              </div>

              <div>
                <div style={{ fontSize: 'var(--font-size-sm)', color: 'var(--gray-600)', marginBottom: 'var(--spacing-xs)' }}>
                  Variance
                </div>
                <div style={{
                  fontSize: 'var(--font-size-2xl)',
                  fontWeight: 600,
                  color: variance > 0 ? 'var(--warning)' : variance < 0 ? 'var(--error)' : 'var(--success)'
                }}>
                  {variance > 0 ? '+' : ''}{variance.toFixed(1)}h
                </div>
              </div>

              <div className="progress-bar">
                <div
                  className="progress-bar-fill"
                  style={{
                    width: `${Math.min((weeklyTotal / plannedHours) * 100, 100)}%`,
                    background: weeklyTotal > plannedHours ? 'var(--warning)' : 'var(--success)'
                  }}
                />
              </div>
              <div style={{ fontSize: 'var(--font-size-sm)', color: 'var(--gray-600)' }}>
                {((weeklyTotal / plannedHours) * 100).toFixed(0)}% of planned hours
              </div>
            </>
          )}

          {!hasWeeklyPlan && (
            <div className="p-4 bg-red-50 dark:bg-red-900/20 border-2 border-red-500 dark:border-red-700 rounded-lg text-red-900 dark:text-red-100">
              No weekly plan found for this week. Create a plan to compare actual vs planned hours.
            </div>
          )}
        </div>
      </Card.Body>
    </Card>
  );
};

export default WeeklySummaryCard;
